// 步骤切换功能
var cc = "";
  // 辅助函数：获取单选按钮值
  function getRadioValue(name) {
    const checkedRadio = document.querySelector(`input[name="${name}"]:checked`)
    return checkedRadio ? checkedRadio.value : null
  }
  // 辅助函数：获取表单字段值
  function getFormValue(name) {
    const field = document.querySelector(`[name="${name}"]`)
    return field ? field.value : ''
  }

const tradeDialogState = new WeakMap()

function getTradeDialogFocusables(dialog) {
  return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
    .filter((element) => !element.closest('[hidden], [inert], [aria-hidden="true"]') && window.getComputedStyle(element).visibility !== 'hidden' && element.getClientRects().length > 0)
}

function isolateTradeDialog(dialog) {
  const isolated = []
  let current = dialog
  while (current && current !== document.body) {
    const parent = current.parentElement
    if (!parent) break
    Array.from(parent.children).forEach((sibling) => {
      if (sibling === current || sibling.contains(dialog) || sibling.hasAttribute('inert')) return
      sibling.setAttribute('inert', '')
      isolated.push(sibling)
    })
    current = parent
  }
  return isolated
}

function handleTradeDialogKeydown(event) {
  const dialog = event.currentTarget
  if (event.key === 'Escape') {
    event.preventDefault()
    closeTradeDialog(dialog)
    return
  }
  if (event.key !== 'Tab') return
  const focusables = getTradeDialogFocusables(dialog)
  if (!focusables.length) {
    event.preventDefault()
    dialog.querySelector('[tabindex="-1"]')?.focus()
    return
  }
  const first = focusables[0]
  const last = focusables[focusables.length - 1]
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first.focus()
  }
}

function openTradeDialog(dialog, trigger) {
  if (!dialog || !dialog.hidden) return
  const bodyState = { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight }
  dialog.hidden = false
  dialog.classList.add('popup_show')
  tradeDialogState.set(dialog, { trigger: trigger || document.activeElement, isolated: isolateTradeDialog(dialog), bodyState })
  document.body.style.paddingRight = window.innerWidth - document.body.offsetWidth + 'px'
  document.body.style.overflow = 'hidden'
  dialog.addEventListener('keydown', handleTradeDialogKeydown)
  ;(dialog.querySelector('[data-dialog-close]') || dialog.querySelector('[tabindex="-1"]'))?.focus()
}

function closeTradeDialog(dialog, restoreFocus = true) {
  if (!dialog) return
  const state = tradeDialogState.get(dialog)
  dialog.classList.remove('popup_show')
  dialog.hidden = true
  dialog.removeEventListener('keydown', handleTradeDialogKeydown)
  state?.isolated.forEach((element) => element.removeAttribute('inert'))
  if (state) {
    document.body.style.overflow = state.bodyState.overflow
    document.body.style.paddingRight = state.bodyState.paddingRight
  }
  if (restoreFocus && state?.trigger && document.contains(state.trigger)) state.trigger.focus()
  tradeDialogState.delete(dialog)
}

function checklogin(){
  if (isShopifyCustomerLoggedIn()) {
      console.log("用户已登录（通过 Cookie 检测）");
    return true;
    } else {
      console.log("用户未登录");
    
    const popup = document.querySelector('.trade_find .popup')
      closeTradeDialog(popup, false)
      document.body.style.paddingRight = ''
      document.body.style.overflow = ''
      // 存储当前页面URL到localStorage
      localStorage.setItem('returnToAfterLogin', window.location.href);
      // 跳转到登录页
      window.location.href = '/account/login?checkout_url=' + encodeURIComponent(window.location.pathname);
          return false;
      }
  
}
function showStep(stepNumber) {
   if(stepNumber!=1&&!checklogin()){
     return; 
  }
  if(stepNumber==2){
    
  }
  if(stepNumber==3){
	  const discountprice = getSuggestprice(
        getFormValue('productCode'),
        getFormValue('new_buydate'),
        getRadioValue('dreame_userfuction') === 'yes'
      );
	 if(discountprice==null){
     layer.msg(window.translations.msg1017)
      return ;
    }else{
	  document.getElementById('discountp').innerHTML=discountprice+" €";
      }
  }
  // 隐藏所有步骤
  const allSteps = document.querySelectorAll('.trade_find .popup .form')
  if(allSteps){
    allSteps.forEach((step) => {
      step.style.display = 'none'
    })
  
    // 显示当前步骤
    const currentStep = allSteps[stepNumber - 1]
    if (currentStep) {
      currentStep.style.display = 'block'
    }
    }
}

// 重置所有表单
function resetAllForms() {
  // 重置所有表单元素
  const allForms = document.querySelectorAll('.trade_find .popup form')
  allForms.forEach((form) => {
    form.reset()
  })
 const imageListContainer = document.getElementById('product-image-list')

      // 清空当前图片列表
      if (imageListContainer) {
        imageListContainer.innerHTML = ''
      }
  // 清空图片预览列表
  const imageList = document.getElementById('image-preview-list')
  if (imageList) {
    imageList.innerHTML = ''
  }

  // 清空已上传文件数组
  if (typeof uploadedFiles !== 'undefined') {
    uploadedFiles = []
  }

  // 清空文件ID数组
  if (typeof proofannIdList !== 'undefined') {
    proofannIdList = []
  }

  // 移除所有单选按钮的active类
  const radioItems = document.querySelectorAll('.radio-item')
  radioItems.forEach((item) => {
    item.classList.remove('active')
  })

  // 重置为第一步
  showStep(1)
}
document.addEventListener('shopify:section:load', function(event) {
  console.log('Section loaded:', event.detail.sectionId);
   initContent();
});
document.addEventListener('DOMContentLoaded', () => {
  initContent();
})
function initContent(){

  console.log("DOMContentLoadedDOMContentLoadedDOMContentLoaded");
  const tradeFind = document.querySelector('.trade_find')
  if (!tradeFind || tradeFind.dataset.initialized === 'true') return
  const interactionEnabled = typeof carouselInteractionEnabled === 'undefined' || carouselInteractionEnabled
  const swiperElement = tradeFind.querySelector('.m_swiper')
  // 初始化轮播图
  if (swiperElement && typeof Swiper !== 'undefined') new Swiper(swiperElement, {
    spaceBetween: 20,
    centeredSlides:  window.innerWidth < 768,
    slidesPerView: 3,
    loop: false,
    allowTouchMove: interactionEnabled,
    pagination: {
      el: tradeFind.querySelector('.trade_find_pagination'),
      clickable: interactionEnabled
    },
    navigation: {
      nextEl: tradeFind.querySelector('.trade_find_next'),
      prevEl: tradeFind.querySelector('.trade_find_prev')
    },
    breakpoints: {
      990: {
        spaceBetween: 15,
        slidesPerView: 2.3
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 1.8
      }
    },
    on: {
      init: function () {
        const section = document.querySelector('.trade_find_section')
        if (section) {
          section.classList.remove('loading')
        }
        if(!interactionEnabled){
          tradeFind.querySelectorAll('.swiper_btns').forEach(item => {
            item.classList.add('swiperhidden');
          });
          
          tradeFind.querySelectorAll('.trade_find_pagination').forEach(item => {
            item.classList.add('swiperhidden');
          });
        }
      }
    }
  })
  // 初始化时只显示第一步
  showStep(1)
  // popup相关功能
  const buttons = document.querySelectorAll('.trade_find .trade_find_button')
  const popup = document.querySelector('.trade_find .popup')
  const closeBtn = document.querySelector('.trade_find .popup .close')
  const cover = document.querySelector('.trade_find .popup .popup_cover')

  // 点击按钮显示弹窗
  if(buttons)
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
   if (checklogin()) {
      openTradeDialog(popup, button)
      const dataType = button.getAttribute('datatype');; // 获取 data-type 的值
      console.log(dataType);
      skutype=dataType;
      skusOptions();
      populatePhonePrefixOptions() ;
    }
    })
  })

  // 点击关闭按钮隐藏弹窗
    if(closeBtn)
  closeBtn.addEventListener('click', () => {
    closeTradeDialog(popup)
    // 不重置表单，保留用户数据
    resetAllForms();
  })
  // 点击遮罩层隐藏弹窗
      if(cover)
  cover.addEventListener('click', () => {
   // popup.classList.remove('popup_show')
    //document.body.style.paddingRight = ''
    //document.body.style.overflow = ''
    // 不重置表单，保留用户数据
  })
  tradeFind.dataset.initialized = 'true'
}

// layui功能
layui.use(['form', 'laydate', 'upload'], function () {
  const form = layui.form
  const laydate = layui.laydate
  const $ = layui.$

  // 监听产品选择变化
  // 监听产品选择变化
  form.on('select()', function (data) {
    // 检查是否是产品选择下拉框
    if (data.elem.name === 'productCode') {
      const productId = data.value
      const imageListContainer = document.getElementById('product-image-list')

      // 清空当前图片列表
      if (imageListContainer) {
        imageListContainer.innerHTML = ''

        // 如果选择了产品且有对应的图片
        if (productId && productImages[productId]) {
          // 添加产品图片到列表
          productImages[productId].forEach((imgSrc) => {
            const imgElement = `
  <div class="image-preview">
  <img src="${imgSrc}&width=138&height=138" previewsrc="${imgSrc}" alt="Product Image" class="product-preview-img" style="cursor: pointer;">
  </div>
  `
            imageListContainer.innerHTML += imgElement
          })

          // 为新添加的图片绑定点击预览事件
          $(imageListContainer)
            .find('.product-preview-img')
            .on('click', function () {
              const imgSrc = $(this).attr('previewsrc')
              showImagePreview(imgSrc)
            })
        }
      }
    }
	
	 if (data.elem.name === 'countryCode') {
		 console.log(data.value);
		 var selectedName = $(data.elem).find('option:selected').text();
		cc=selectedName;
		provinceOptions();
    }

    // 检查是否是电话前缀选择下拉框
    if (data.elem.name === 'phonePrefix') {
      // 获取选中的option元素
      const selectedOption = data.elem.options[data.elem.selectedIndex]
      if (selectedOption && selectedOption.getAttribute('data-display')) {
        // 修改显示文本为只显示电话前缀
        const displayText = selectedOption.getAttribute('data-display')
        $(data.othis).find('.layui-select-title input').val(displayText)

        // 创建自定义显示覆盖层，只显示图标和手机号前缀
        setTimeout(() => {
          const phonePrefixContainer = data.elem.closest('.phone-prefix')
          const layuiSelectDiv = phonePrefixContainer.querySelector('.layui-form-select')
          const layuiInput = layuiSelectDiv.querySelector('.layui-input')

          // 移除之前的覆盖层（如果存在）
          const existingOverlay = phonePrefixContainer.querySelector('.is_overlay')
          if (existingOverlay) {
            existingOverlay.remove()
          }
        var currSvg = iconphone[selectedOption.getAttribute('data-code')];
          // 创建新的覆盖层
          const overlay = document.createElement('div')
          overlay.className = 'is_overlay'
          var mSvg = `<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns=" http://www.w3.org/2000/svg ">
            <g clip-path="url(#clip0_289_1580)">
              <path d="M16.0002 0.400024H0V12.3482H16.0002V0.400024Z" fill="#006A44"/>
              <path d="M16.0002 8.41833H0V12.4005H16.0002V8.41833Z" fill="#C1272D"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.400024H16.0005V4.38223H0V0.400024Z" fill="#FDB913"/>
            </g>
            <defs>
              <clipPath id="clip0_289_1580">
                <rect width="16" height="12" fill="white" transform="translate(0 0.400024)"/>
              </clipPath>
            </defs>
          </svg>`
          if(currSvg)
            mSvg=currSvg;
          overlay.innerHTML = `${mSvg}<span>${displayText}</span>`
          // 添加覆盖层
          layuiSelectDiv.appendChild(overlay)

          // 点击覆盖层时触发原始选择器
          overlay.style.pointerEvents = 'auto'
          overlay.style.cursor = 'pointer'
          overlay.addEventListener('click', () => {
            layuiInput.click()
          })
        }, 100)
      }
    }
  })

// 监听 select 下拉框展开事件,c重试3次
  $(document).on('click', '.layui-form-select', function(){
    
    setTimeout(function(){
      console.log($(".layui-form-selected").find('.layui-anim').find(".layui-this").length,$(".layui-form-selected").find('.layui-anim')[0],$(".layui-form-selected").find('.layui-anim')[0].scrollTop)

        var anim =$(".layui-form-selected").find('.layui-anim');
            var currentSelected = anim.find(".layui-this");
            var firstOption = anim.find("dd").first();
      if (currentSelected.is(firstOption)) {
		  if ($(".layui-form-selected").find('.layui-anim')[0] === undefined) {
            console.log("settime11111111")
            setTimeout(function(){
			     
					  if ($(".layui-form-selected").find('.layui-anim')[0] === undefined) {
            console.log("settime22222222222")
					        setTimeout(function(){
					     
							  if ($(".layui-form-selected").find('.layui-anim')[0] === undefined) {
					        
                                  console.log("settime333333333end")
							  }else{
								  $(".layui-form-selected").find('.layui-anim')[0].scrollTop = 0;
							  }
					    }, 100);
					  }else{
						  $(".layui-form-selected").find('.layui-anim')[0].scrollTop = 0;
					  }
			    }, 100);
		  }else{
			  $(".layui-form-selected").find('.layui-anim')[0].scrollTop = 0;
		  }
      }
    }, 200); // 延迟 100ms 确保下拉框已渲染
  });
  // ===== 表单验证和提交功能 =====
  // 自定义验证规则
  form.verify({
    proofOfPurchase: function (value, item) {
      // 检查是否上传了图片
      const imageList = document.getElementById('image-preview-list')
      if (!imageList || imageList.children.length === 0) {
        return window.translations.msg1011
      }
    },
    serialNumber: function (value, item) {
      // 检查序列号格式
      if (!value || value.trim() === '') {
         return window.translations.msg1013
      }

      const trimmedValue = value.trim()

      // 检查长度是否在18-23之间
      if (trimmedValue.length < 18 || trimmedValue.length > 23) {
       return window.translations.msg1014
      }

      // 检查是否以大写字母开头
      if (!/^[A-Z]/.test(trimmedValue)) {
        return window.translations.msg1015
      }

      // 检查是否只包含字母和数字
      if (!/^[A-Za-z0-9]+$/.test(trimmedValue)) {
       return window.translations.msg1016
      }
    }
  })

  // 第一步表单提交事件
  form.on('submit(formDemo)', function (data) {
    // 验证用户是否同意条款
    if (!data.field.agree1) {
      layer.msg(window.translations.msg1001)
      return false
    }
    if (!data.field.agree2) {
      layer.msg(window.translations.msg1001)
      return false
    }
     
     fetch(globalUrl +'/api/v1/tradein/checkSn', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
  'Accept-Language': LanguageUtils.getStandardLanguage(Shopify.local),
  'User-Language': LanguageUtils.getStandardLanguage(Shopify.local)
      },
      body: '{"new_userprofile_number":"'+getFormValue('new_userprofile_number')+'"}'
    })
      .then((response) => {
        // 关闭加载提示

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then((result) => {
        console.log('API响应成功:', result)
        let code = result.data.code;
        if (code ==500){
      layer.msg(window.translations.msg1018)
      return false
    }else{showStep(2)
      return true;
    }
      
  });
     
    // 验证通过，可以进行下一步操作
    // 切换到第二步
    console.log(data.field)
    return false // 阻止表单跳转
  })

  // 第二步表单提交事件
  form.on('submit(formDemo2)', function (data) {
    // 校验第二步必填项
    const malfunctionValue = getRadioValue('dreame_userfuction')
    const scratchesValue = getRadioValue('dreame_userintact')

    // 检查是否选择了产品故障状态
    if (!malfunctionValue) {
      layer.msg(window.translations.msg1021, { icon: 2 })
      return false
    }

    // 检查是否选择了外观划痕状态
    if (!scratchesValue) {
      layer.msg(window.translations.msg1022, { icon: 2 })
      return false
    }

    // 校验通过，切换到第三步
    showStep(3)
    console.log(data.field)
    return false // 阻止表单跳转
  })

  // 第三步表单提交事件
  form.on('submit(formDemo3)', function (data) {
    // 切换到第四步
    showStep(4)
    console.log(data.field)
    return false // 阻止表单跳转
  })

  // 第四步表单提交事件
  form.on('submit(formDemo4)', function (data) {
    // 验证用户是否同意条款
    if (!data.field.agreePrivacy) {
      layer.msg(window.translations.msg1001)
      return false
    }
    if (!data.field.agreeProcess) {
      layer.msg(window.translations.msg1001)
      return false
    }

    // 验证通过，可以进行提交操作
    // 根据表格配置字段构建提交对象
    const submitData = {
      // 基本信息字段
      firstName: data.field.firstName || '',
      lastName: data.field.lastName || '',
      new_email: data.field.new_email || '',
      new_feedbacktel: data.field.new_feedbacktel || '',
      new_contact: (data.field.firstName || '') + ' ' + (data.field.lastName || ''),
      new_type: 90, // 固定值：检测中
      countryCode: data.field.countryCode || '',
      provinceCode: data.field.provinceCode || '',
      new_city: data.field.newCity || '',
      new_postal_code: data.field.new_postal_code || '',
      new_address: data.field.new_address || '',
      new_memo: data.field.new_memo || '',

      // 产品状态字段
      dreame_userfuction: getRadioValue('dreame_userfuction') === 'yes',
      dreame_userintact: getRadioValue('dreame_userintact') === 'yes',
      dreame_suggestprice: getSuggestprice(
        getFormValue('productCode'),
        getFormValue('new_buydate'),
        getRadioValue('dreame_userfuction') === 'yes'
      ), // 示例价格，实际应从第三步获取

      // 产品信息字段（需要从前面步骤获取）
      // dreame_shopifyid: 'JHY3432432', // 示例ID
      new_userprofile_number: getFormValue('new_userprofile_number') || '',
      productCode: getFormValue('productCode') || '',
      proofannIdList: proofannIdList.length > 0 ? proofannIdList : [],
      new_buydate: getFormValue('new_buydate') ? new Date(getFormValue('new_buydate')).toISOString() : '',
      new_number: 1, // 固定数量
      purchasechannel_2code: getFormValue('purchasechannel_2code') || '',
      new_ordernumber: getFormValue('new_ordernumber') || ''
    }

    // 在控制台打印配置字段数据
    console.log('提交的表格配置字段数据:', submitData)

    // 显示加载提示
    const loadingIndex = layer.load(1, {
      shade: [0.3, '#000']
    })

    // 提交数据到API
    submitToAPI(submitData, loadingIndex)

    return false // 阻止表单跳转
  })
   
// 提交数据到API的函数
 // function checkSn(new_userprofile_number) {
    
  //}
  // 提交数据到API的函数
  function submitToAPI(submitData, loadingIndex) {
    fetch(globalUrl +'/api/v1/tradein/createRecycleRma', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
  'Accept-Language': LanguageUtils.getStandardLanguage(Shopify.local),
  'User-Language': LanguageUtils.getStandardLanguage(Shopify.local)
      },
      body: JSON.stringify(submitData)
    })
      .then((response) => {
        // 关闭加载提示
        layer.close(loadingIndex)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then((result) => {
        console.log('API响应成功:', result)

        // 检查API返回的状态
        if (result.success || result.code === 200 || result.status === 'success') {
          // 提交成功，显示成功消息并切换到第五步
          layer.msg(window.translations.msg1003, { icon: 1 })
          
          if(result.data.dreame_islv==1){
            const successMessage = document.querySelector('.form5 .success-info .success-message');
            const nobakMessage = document.querySelector('.form5 .success-info .success-message-noback');
            if (successMessage) {
                successMessage.classList.add('hidemsg');
            }
            if(nobakMessage){
               nobakMessage.classList.remove('hidemsg');
            }
          }else{
            const successMessage = document.querySelector('.form5 .success-info .success-message');
            const nobakMessage = document.querySelector('.form5 .success-info .success-message-noback');
            if (successMessage) {
                successMessage.classList.remove('hidemsg');
            }
            if(nobakMessage){
               nobakMessage.classList.add('hidemsg');
            }
          }
          

          // 提交成功后清空所有表单数据
          resetAllForms()
          showStep(5)
        } else {
          // API返回错误状态
          const errorMsg = result.message || result.msg || window.translations.msg1004
          
          showErrorMsg(errorMsg);
        }
      })
      .catch((error) => {
        // 关闭加载提示
        layer.close(loadingIndex)

        console.error('API请求失败:', error)

        // 显示错误消息
        let errorMsg = window.translations.msg1005
        if (error.message.includes('Failed to fetch')) {
          errorMsg = window.translations.msg1006
        } else if (error.message.includes('HTTP error')) {
          errorMsg = window.translations.msg1007
        }

        layer.msg(errorMsg, { icon: 2 })
      })
  }

  // 辅助函数：为文件生成ID
  function generateFileId(file) {
    return '9a912f72-0a04-0a6d-0000-071df72136b5'
  }

  // ===== 表单重置和返回功能 =====
  // 第一步表单重置事件
  $('.form')
    .eq(0)
    .find('button[type="reset"]')
    .on('click', function () {
      // 获取当前表单
      const currentForm = $(this).closest('form')[0]

      // 重置当前表单
      currentForm.reset()

      // 只清空第一步相关的内容
      // 清空图片预览列表（第一步的上传文件）
      $(this).closest('.form').find('#image-preview-list').empty()
      // 清空已上传文件数组
      uploadedFiles = []
      // 清空文件ID数组
      proofannIdList = []

      // 清空产品图片列表（第一步的产品选择图片）
      $(this).closest('.form').find('#product-image-list').empty()

      // 阻止默认的重置行为，因为我们已经手动重置了
      return false
    })

  // 第二步表单返回事件（返回按钮）
  $('.form')
    .eq(1)
    .find('button[type="reset"]')
    .on('click', function () {
      // 返回到第一步，不重置表单数据
      showStep(1)

      // 阻止默认的重置行为
      return false
    })

  // 第三步表单返回事件（返回按钮）
  $('.form')
    .eq(2)
    .find('button[type="reset"]')
    .on('click', function () {
      // 返回到第二步，不重置表单数据
      showStep(2)
      return false
    })

  // 第四步表单返回事件（返回按钮）
  $('.form')
    .eq(3)
    .find('button[type="reset"]')
    .on('click', function () {
      // 返回到第三步，不重置表单数据
      showStep(3)
      return false
    })

  // ===== 日期选择器 =====
  // 初始化日期选择器
  laydate.render({
    elem: '#purchase-date',
    format: 'yyyy-MM-dd',
     max: new Date().toLocaleDateString(),
    lang: 'en'
  })

  // ===== 文件上传和预览功能 =====
  // 存储已上传的文件
  let uploadedFiles = []
  // 存储上传后的文件ID
  let proofannIdList = []

  // 点击上传按钮触发文件选择
  $('#upload_btn').on('click', function () {
    $('#file_upload').click()
  })

  // 监听文件选择变化
  $('#file_upload').on('change', async function (e) {
    const files = e.target.files
    if (!files.length) return

    // 按顺序处理选择的文件
    for (let i = 0; i < files.length; i++) {
      const file = files[i]

      // 检查文件类型
      const isPdf = file.type === 'application/pdf'
      const isImage = file.type.match('image.*')

      if (!isImage && !isPdf) {
        layui.layer.msg(window.translations.msg1008)
        continue
      }

      // 添加到已上传文件列表
      uploadedFiles.push(file)


      // 按顺序上传文件到API（等待当前文件上传完成后再上传下一个）
      await uploadFileToAPI(file)
    }

    // 清空文件输入，允许重复选择同一文件
    this.value = ''
  })

  // 上传文件到API的函数
  async function uploadFileToAPI(file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('fileName', file.name)

      const formData1 = new FormData()
      formData1.append('fileName', file.name)
      // 显示上传进度提示
      const loadingMsg = layer.msg(window.translations.msg1012, {
        icon: 16,
        shade: 0.3,
        time: 0 // 不自动关闭
      })
    const MAX_FILE_SIZE = 50 * 1024 * 1024;
    const fileSize = file.size;

    // 检查文件大小是否超过限制
    if (fileSize > MAX_FILE_SIZE) {
      throw new Error(`Individual files must not exceed 50 MB`);
      return;
    }
fetch(globalUrl +'/api/v1/tradein/proofannUrl', {
        method: 'POST',headers: {
          'Accept-Language': LanguageUtils.getStandardLanguage(Shopify.local),
  'User-Language': LanguageUtils.getStandardLanguage(Shopify.local)
        },
        body: formData1
      }) .then((response) => {
          layer.close(loadingMsg)

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then((result) => {
          console.log('文件上传地址获取成功:', result)
  fetch(result.data, {
        method: 'POST',headers: {
  'Accept-Language': LanguageUtils.getStandardLanguage(Shopify.local),
  'User-Language': LanguageUtils.getStandardLanguage(Shopify.local)
},
        body: formData
      })
        .then((response) => {
          layer.close(loadingMsg)

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then((result) => {
          console.log('文件上传成功:', result)

         
          // 检查API返回的状态并获取文件ID
          // 根据实际返回格式：{"ErrorCode":0,"Message":null,"Data":["文件ID"]}
          if (result.ErrorCode === 0) {
            console.log(result)
            // 从Data数组中获取文件ID
            if (result.Data && Array.isArray(result.Data) && result.Data.length > 0) {
              const fileId = result.Data[0] // 取数组第一个元素作为文件ID
              proofannIdList.push(fileId)
              console.log('文件ID已添加到列表:', fileId)
              layer.msg(window.translations.msg1009, { icon: 1, time: 2000 })
              resolve(result) // 上传成功，resolve Promise
             // 创建预览
          createPreview(file)
            } else {
              console.warn('API返回成功但未找到文件ID:', result)
              layer.msg(window.translations.msg1010, { icon: 2, time: 3000 })
              resolve(result) // 虽然没有文件ID，但API调用成功
            }
          } else {
            const errorMsg = result.Message || window.translations.msg1010
            layer.msg(errorMsg, { icon: 2, time: 3000 })
            reject(new Error(errorMsg)) // 上传失败，reject Promise
          }
        })
        .catch((error) => {
          layer.close(loadingMsg)
          console.error('文件上传失败:', error)

          let errorMsg = '文件上传失败，请重试'
          if (error.message.includes('Failed to fetch')) {
            errorMsg = '网络连接失败，请检查网络后重试'
          } else if (error.message.includes('HTTP error')) {
            errorMsg = '服务器错误，请稍后重试'
          }

          layer.msg(window.translations.msg1010, { icon: 2, time: 3000 })
          reject(error) // 捕获到错误，reject Promise
        })
          
        })   
    }) // 结束Promise构造函数
  }

  // 清除文件输入
  function clearFileInput() {
    const fileInput = document.getElementById('file_upload')
    if (fileInput) {
      fileInput.value = ''
    }
  }

  // 创建预览（图片或PDF）
  function createPreview(file) {
    const isPdf = file.type === 'application/pdf'
    const reader = new FileReader()

    reader.onload = function (e) {
      const previewId = 'preview-' + Date.now() + '-' + Math.floor(Math.random() * 1000)
      let previewHtml = ''

      if (isPdf) {
        // PDF文件使用SVG图标并显示文件名
        previewHtml = `
           <div class="image-preview" id="${previewId}">
             <div class="pdf-icon" data-pdf-url="${e.target.result}" title="${file.name}">
               <svg t="1749281253966" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4463" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64">
                 <path d="M704 0H192c-35.328 0-64 28.672-64 64v320h576c35.328 0 64 28.672 64 64v415.744c0 35.328-28.672 64-64 64H128v31.744c0 35.328 28.672 64 64 64h768c35.328 0 64-28.672 64-64v-640L704 0z" fill="#EAEAEA" p-id="4464"></path>
                 <path d="M704 0v256c0 35.328 28.672 64 64 64h256L704 0z" fill="#434854" p-id="4465"></path>
                 <path d="M768 320l256 256V320z" opacity=".1" p-id="4466"></path>
                 <path d="M704 832c0 17.92-14.336 31.744-31.744 31.744H31.744C13.824 863.744 0 849.408 0 832V480.256c0-17.92 14.336-31.744 31.744-31.744h640c17.92 0 31.744 14.336 31.744 31.744V832z" fill="#CD4050" p-id="4467"></path>
                 <path d="M192 544.256h-48.128c-8.704 0-15.872 7.168-15.872 15.872v192c0 8.704 7.168 15.872 15.872 15.872s15.872-7.168 15.872-15.872v-79.872h31.744c35.328 0 64-28.672 64-64s-28.16-64-63.488-64z m158.72 0c34.816 0 62.976 27.648 64 62.464v97.792c0 34.816-27.648 62.976-62.464 64h-49.664c-8.704 0-15.36-6.656-15.872-14.848V560.64c0-8.704 6.656-15.36 14.848-15.872h49.152z m227.328 0c8.704 0 15.872 7.168 15.872 15.872S586.752 576 578.048 576h-80.384v64h48.128c8.704 0 15.872 7.168 15.872 15.872s-7.168 15.872-15.872 15.872h-48.128v79.872c0 8.704-7.168 15.872-15.872 15.872s-15.872-7.168-15.872-15.872v-192c0-8.704 7.168-15.872 15.872-15.872h96.256zM350.72 576h-31.744v159.744h31.744c17.408 0 31.232-13.824 31.744-30.72v-97.28C382.976 590.336 368.64 576 350.72 576zM192 576c17.92 0 31.744 14.336 31.744 31.744S209.92 640 192 640h-31.744v-64H192z" fill="#FFFFFF" p-id="4468"></path>
               </svg>
               <div class="pdf-filename">${file.name}</div>
             </div>
             <div class="remove-btn" data-id="${previewId}">×</div>
           </div>
         `
      } else {
        // 图片文件使用缩略图
        previewHtml = `
          <div class="image-preview" id="${previewId}">
            <img src="${e.target.result}" alt="Preview" class="preview-thumbnail">
            <div class="remove-btn" data-id="${previewId}">×</div>
          </div>
        `
      }

      $('#image-preview-list').append(previewHtml)

      // 绑定删除按钮事件
      $(`#${previewId} .remove-btn`).on('click', function (e) {
        e.stopPropagation() // 阻止事件冒泡，防止触发预览
        const id = $(this).data('id')
        $(`#${id}`).remove()

        // 从已上传文件列表中移除
        const index = uploadedFiles.findIndex(function (f) {
          return f.name === file.name && f.size === file.size
        })
        if (index !== -1) {
          uploadedFiles.splice(index, 1)
          // 同时从proofannIdList中移除对应的ID
          if (index < proofannIdList.length) {
            const removedId = proofannIdList.splice(index, 1)[0]
            console.log('已从ID列表中移除:', removedId)
          }
        }
      })

      if (!isPdf) {
        // 只为图片添加点击预览功能
        $(`#${previewId} .preview-thumbnail`).on('click', function () {
          const imgSrc = $(this).attr('src')
          showImagePreview(imgSrc)
        })
      }
    }

    reader.readAsDataURL(file)
  }

  // 图片预览弹窗功能
  const imagePreviewPopup = $('.image-preview-popup')
  const previewImage = $('.preview-image')
  const previewClose = $('.preview-close')
  const previewPopupCover = $('.preview-popup-cover')

  // 显示图片预览弹窗
  function showImagePreview(imgSrc) {
    previewImage.attr('src', imgSrc)
    openTradeDialog(imagePreviewPopup[0], document.activeElement)
  }

  // 关闭图片预览弹窗
  function closeImagePreview() {
    closeTradeDialog(imagePreviewPopup[0])
  }

  // 绑定关闭按钮事件
  previewClose.on('click', closeImagePreview)
  previewPopupCover.on('click', closeImagePreview)

  // ===== 自定义单选按钮功能 =====
  // 自定义单选按钮点击事件
  $('.radio-item').on('click', function () {
    const name = $(this).data('name')
    const value = $(this).data('value')

    // 移除同组按钮的active类
    $(`.radio-item[data-name="${name}"]`).removeClass('active')

    // 为当前按钮添加active类
    $(this).addClass('active')

    // 选中对应的radio输入
    $(this).find('input[type="radio"]').prop('checked', true)

    console.log(`选择了 ${name}: ${value}`)
  })
})

function getTimePeriod(inputDate) {
  const today = new Date()
  const input = new Date(inputDate)

  // 计算月份差异
  const monthsDiff = (today.getFullYear() - input.getFullYear()) * 12 + (today.getMonth() - input.getMonth())

  if (monthsDiff <= 6) {
    return 1
  } else if (monthsDiff <= 12) {
    return 3
  } else {
    return 5
  }
}
function getSuggestprice(sku_code, new_buydate, functionflag) {
  let addnum = functionflag == true ? 0 : 1
  let t_level = getTimePeriod(new_buydate)+addnum
  console.log(sku_code,t_level,functionflag,(functionflag == true));
  return getPriceBySku(sku_code, t_level)
}

function getPriceBySku(sku_code, t_level) {
  const priceData = dictionaries.tradeInSkus

  // 找到匹配的 SKU
  const product = priceData.find((item) => item.sku_code === sku_code)

  if (!product) {
    return null // 或者可以抛出错误
  }

  // 获取对应的 t 值
  const t_key = `t${t_level}`
  if (product.hasOwnProperty(t_key)) {
    return product[t_key]
  }

  return null // 如果 t 级别不存在
}
